var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BConversion',{attrs:{"left-label1":"原始文本","left-label2":"比如 'hello world'","right-label1":"URL编码后的文本","right-label2":"hello%20world","left-button":"encode","right-button":"decode","forward-fn":_vm.encodeUrl,"reverse-fn":_vm.decodeUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }